var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBoldIconNewinline = function SvgBoldIconNewinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 32,
    viewBox: "0 0 90 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.159 21.706h22.288C48.911 27.472 44.119 32 38.302 32c-5.817 0-10.608-4.527-11.144-10.293zM11.257 9.32v22.629c5.677-.544 10.137-5.41 10.137-11.315 0-5.904-4.46-10.769-10.137-11.313zm27.046-.051c-5.816 0-10.608 4.529-11.144 10.295h22.288c-.536-5.766-5.328-10.295-11.145-10.295zM0 17.528V32h9.079V0H0v17.527zM80.919 0v32h9.078V0H80.92zm-12.25 20.634c0 .719.069 1.42.195 2.102.911 4.92 4.956 8.733 9.942 9.21V9.32c-5.676.544-10.136 5.41-10.136 11.315h-.001zm-14.63 11.365h9.078V0h-9.079v32z",
    fill: "url(#bold-icon-new_inline_svg__paint0_linear_2684_3522)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bold-icon-new_inline_svg__paint0_linear_2684_3522",
    x1: 89.997,
    y1: 16,
    x2: 0,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#EE424E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#121E6C"
  })))));
};
export default SvgBoldIconNewinline;